module.exports = __webpack_public_path__ + "img/bannerGreen.ef2dc5ba.jpg";